import React from 'react';
import classNames from 'classnames';
import { SIZES } from './constants';
const Loader = ({ size = SIZES.small }) => {
  const loaderClassName = classNames('ws-ui-loader', `ws-ui-loader--${size}`);

  return (
    <div className={loaderClassName}>
      <div className="ws-ui-loader__dot" />
      <div className="ws-ui-loader__dot" />
      <div className="ws-ui-loader__dot" />
    </div>
  );
};

export default Loader;
